import { render, staticRenderFns } from "./consultation-details.vue?vue&type=template&id=5cfca1b9&"
import script from "./consultation-details.vue?vue&type=script&lang=js&"
export * from "./consultation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports